import { expected, format } from '@aloft/toolkit-shared';
import { colors } from '@aloft/toolkit-sui';

import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { SiteToValueRatioChartData } from './types.ts';

/** @deprecated - Use SiteToValueRatioGraph instead */
export const SiteToValueRatioChartUnwrapped = ({
  data,
  isLoading = false,
  disableAnimations = false,
  width,
  height,
  dots,
}: {
  data: SiteToValueRatioChartData[];
  isLoading?: boolean;
  disableAnimations?: boolean;
  width?: number;
  height?: number;
  dots?: string;
}) => (
  <ResponsiveContainer width={width ?? '100%'} height={height ?? 300}>
    <BarChart data={data} barGap={0}>
      <CartesianGrid vertical={false} />
      <Legend />
      {!disableAnimations && <Tooltip formatter={(val): string => expected(format.percent(val))} />}
      <YAxis
        orientation="left"
        tickFormatter={(val) => expected(format.percent(val, 0))}
        width={80} // to accommodate the label
      >
        <Label angle={-90} position="left" offset={-5}>
          Site to Value Ratio
        </Label>
      </YAxis>
      <XAxis dataKey="siteName" />
      <Bar
        name={`Assessor's Land to Value Ratio${isLoading ? ` (loading${dots ?? ''})` : ''}`}
        dataKey="marketLandToValueRatio"
        fill={colors.graphChart2}
        isAnimationActive={!disableAnimations}
      />
      <Bar
        name="Site to Value Ratio"
        dataKey="siteToValueRatio"
        fill={colors.graphChart}
        isAnimationActive={!disableAnimations}
      />
    </BarChart>
  </ResponsiveContainer>
);
